import { BACKEND_URL } from "../env";
import { Client } from "../types/entities";

export async function fetchClients(): Promise<Client[]> {
  try {
    const response = await fetch(`${BACKEND_URL}/clients`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const clients = (await response.json()) as Client[];
    return clients;
  } catch {
    return [];
  }
}

export async function updateClientLanguage(
  clientId: string,
  language: string
): Promise<void> {
  try {
    const response = await fetch(
      `${BACKEND_URL}/clients/${clientId}/language`,
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ language }),
      }
    );

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }
  } catch (e) {
    console.error("Failed to update client language:", e);
  }
}
